
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  ContactStoredData.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\ContactStoredData.ts

import {Contact } from "./Contact";
export class ContactStoredData {

  // int Id
  public Id: number=0;

  // int ContactId
  public ContactId: number=0;

  // string Key
  public Key?: string=null;

  // string Datas
  public Datas?: string=null;

  // Contact Contact
  public Contact: Contact=null;
}